import React from "react";
import Collapsible from "react-collapsible";
import { checkTranslation, conditionalWidth, translate } from "../../../utils/useful";
import { diagramComponents, diagramGroups } from "../../../variables/diagramFunctions";
import LoaderButton from "../../LoaderButton";
import SidebarView from "../../SidebarView";

class DiagramSidebar extends React.Component {

    state = {

        closedGroups: {},
        // showChildsSide: false,
        // sideOpen: true,
        parts: [
            { label: '{{lang}}Rules', key: 'rules', icon: '/assets/icons/useful/action.png' },
            { label: '{{lang}}Inuse', key: 'inuse', icon: '/assets/icons/useful/list-text.png' },
            { label: '{{lang}}Variables', key: 'variables', icon: '/assets/icons/useful/text.svg' },


        ],
        applets: [
            { name: '{{lang}}Accounting', type: 'finance', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Booking', type: 'booking', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Tasking', type: 'tasking', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Commerce', type: 'commerce', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Messenger', type: 'messenger', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Developers', type: 'developers', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Sequence', type: 'sequence', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Drive', type: 'drive', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Rooms', type: 'rooms', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Ticketing', type: 'ticketing', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Social', type: 'social', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Wallet', type: 'wallet', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Question', type: 'question', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Email', type: 'email', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Notebook', type: 'notebook', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Database', type: 'database', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Tracking', type: 'tracking', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Inventory', type: 'inventory', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}Connections', type: 'connections', icon: '/assets/profile-def.png', isParent: true },
            { name: '{{lang}}CRM', type: 'crm', icon: '/assets/profile-def.png', isParent: true },


        ]
    }

    componentDidMount() {
        // $('[draggable=true]').each((index,drag) => {
        //     // draggable.draggable()
        //     // console.log(draggable)
        //     // console.log(index)
        //     drag.draggable();
        // })
        // .draggable()
        // let draggables = document.querySelectorAll('[draggable=true]');
        // draggables = [...draggables]
        // draggables.forEach(draggable => {
        //     console.log(draggable)
        //     draggable.addEventListener('dragstart', (e) => console.log(e));
        // });
        // console.log(draggables)
        //    draggables.forEach(
    }


    // open = () => {
    //     this.sidebarView.open()
    // }

    toggleOpen = (key) => {
        let closedGroups = this.state.closedGroups
        closedGroups[key] = closedGroups[key] == null ? true : !closedGroups[key]
        this.setState({ closedGroups })
    }

    // toggleSideOpen = () => {
    //     let sideClose = this.state.sideClose == null ? true : !this.state.sideClose
    //     this.setState({ sideClose })
    //     if (sideClose) {
    //         this.subSidebarView.closeSidebar()
    //         // this.setState({ showChildsSide: false })
    //     }
    //     if (this.state.selectedParent && !sideClose) {
    //         // this.setState({ showChildsSide: true })
    //         this.subSidebarView.openSidebar()

    //     }
    // }


    showChildsList = (parent) => {


        // this.setState({ showChildsSide: !this.state.showChildsSide })
        if (parent) {
            this.subSidebarView.openSidebar()
            this.setState({ selectedParent: parent })
        } else {
            this.subSidebarView.closeSidebar()
            setTimeout(() => {
                this.setState({ selectedParent: parent })
            }, 500);
        }
    }

    showApplet = (applet) => {
        // console.log(applet)
        if (applet) {
            this.subSidebarView.openSidebar()
            this.setState({ selectedParent: applet })
        }
    }


    onTouchMove = (e, prop) => {
        // console.log("onTouchMove")
        let x
        let y
        if (e.touches) {
            x = e.touches[0].clientX
            y = e.touches[0].clientY
        }

        // console.log(x)
        // console.log(y)

        let id = prop.key

        if (this.state.dragId !== id && this.dragOverId != id) {
            this.setState({ dragId: id })


            // this.dragOverId = id
            // this.animateSorting(this.state.dragId, id)
        }
        let ghost = document.getElementById('drag-ghost')
        // console.log(ghost)

        if (ghost) {
            ghost.style.top = (y - Number(ghost.style.height.replace('px', '')) / 2) + 'px'
            ghost.style.left = (x - Number(ghost.style.width.replace('px', '')) / 2) + 'px'
        }
        // console.log(y)
    }

    onTouchEnd = (e) => {
        this.setState({ dragId: null })
        this.props.onDrop(e)

    }

    onClick = (cprop) => {
        if (cprop.isParent) {
            this.showChildsList(cprop)
        } else {
            if (!this.props.draggable) {

                // this.sidebarView.close()
                // this.subSidebarView.close()
                this.props.onClick(cprop, this.state.selectedParent)
            }
        }
    }


    render() {

        return (
            <div className="h-100">


                <SidebarView width={this.props.width} ref={el => this.sidebarView = el} sideOpen={this.props.sideOpen} hideOverlay={this.props.hideOverlay} paddingTop={'62px'} widthCondition={{ xs: "12", sm: '28%', md: '28%', lg: "28%", xl: "20%" }}>

                    {/* <div className={"sidePanel digramSidePanel " + (conditionalWidth(this.props.width, { xs: '', lg: ' d-none ' })) + " " + (this.state.sideOpen ? '' : 'sideClose')} style={{ width: conditionalWidth(this.props.width, { xs: '80%', md: '200px' }) }}>
                    <div className='sidePanel-content  h-100 blur-back  ' style={{ backgroundColor: '#fff' }} > */}
                    <div className="digramSidePanelList formItems-container pt-3 scroll-no-scrollbar h-100 ">
                        <div className="text-start w-100 px-2 mb-3">
                            <p className="text-semibold text-normal mb-2 px-2" style={{ color: '#101010' }}>{translate('Create the flow')}</p>

                            <div className="mb-2 px-2">
                                <div className="border-radius-8 px-2 py-1" style={{ backgroundColor: '#f6f6f6' }}>
                                    <input className="transpanet-input text-small" placeholder={translate("Search")} />
                                </div>
                            </div>

                            {this.state.parts.map((prop, index) => {
                                return (
                                    <button className=" py-2 px-1 w-100 mt-1  text-start flexcb" style={{ borderBottom: '1px solid #f2f2f2' }}>
                                        {/* <p className="text-semibold text-small color-gray-3">{translate(prop.label)}</p> */}
                                        <div className="flexc">
                                            <img className="mrd-2" src={prop.icon} height={18} />
                                            <p className="text-small text-semibold " style={{ color: '#101010' }}>{checkTranslation(prop.label)}</p>
                                        </div>

                                        <div className="flexc">
                                            <div className="white flexcc" style={{ minWidth: 20, height: 20, backgroundColor: '#007aff', borderRadius: 30 }}>
                                                <p className="text-smaller text-semibold">{index + 1}</p>
                                            </div>
                                            <div className="flexcc">
                                                <img className={"mld-2 transition opacity-2 "} src={'/images/nexts.png'} width="13px" alt="" />
                                            </div>

                                        </div>

                                    </button>
                                )
                            })}


                        </div>



                        <div className="mb-3 pb-2" style={{ borderBottom: '0px solid #eee' }} >
                            <button className="p-0 px-2 mb-2 flexcb w-100" onClick={() => this.setState({ openApplets: !this.state.openApplets })} >
                                <div className="text-start ">
                                    <p className="text-normal text-semibold " style={{ color: '#101010' }}>{translate('Applets')}</p>
                                    {/* <p className="text-smallest " style={{color:'#9ab'}}>This is the description of this section</p> */}
                                </div>
                                <img className={"mld-2 transition opacity-2 " + (!this.state.openApplets ? 'rotate-90' : '')} src={'/images/nexts.png'} width="13px" alt="" />
                            </button>
                            <div className="" style={{ padding: '0px 2px' }}>
                                <Collapsible open={!this.state.openApplets} transitionTime={100}>
                                    <div className="d-flex mb-2" style={{ flexWrap: 'wrap', alignItems: "stretch" }}>
                                        {this.state.applets.map((cprop, index) => {
                                            return (
                                                // <div className="  mb-0" style={{ padding: 2, width: '50%' }} key={cprop.key}>
                                                //     <div className=" h-100 text-center  " onClick={() => { if (cprop.isParent) this.showChildsList(cprop.key) }} onTouchStart={(e) => this.props.onDragStart(e, cprop, 'function')} onDragStart={(e) => this.props.onDragStart(e, cprop, 'function')} onTouchMove={(e) => this.onTouchMove(e, cprop)} onTouchEnd={(e) => this.onTouchEnd(e)} draggable={!cprop.isParent} style={{ backgroundColor: '#f6f6f6', borderRadius: 4, touchAction: "none", position: 'relative', padding: '10px 5px', cursor: !cprop.isParent ? 'move' : 'pointer', borderRadius: 2, border: '1px solid #f2f2f2' }}>
                                                //         <img draggable={false} src={cprop.icon} width="30px" height={'30px'} alt="" style={{ objectFit: 'cover', borderRadius: '30px', userSelect: 'none', WebkitUserSelect: 'none' }} />
                                                //         <p className="mt-0  text-semibold color-gray-3" style={{ fontSize: 11 }} >{checkTranslation(cprop.name)}</p>
                                                //         <p className="mt-0  text-semibold color-gray-2" style={{ fontSize: 10 }} >@username</p>


                                                //         {cprop.isParent && (
                                                //             <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ position: 'absolute', top: 8, right: 8, userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                //         )}
                                                //     </div>
                                                // </div>

                                                <div className="  mb-0" style={{ padding: 2, width: '100%' }} key={cprop.key}>
                                                    <div className="flexcb h-100 text-center  " onClick={() => { if (cprop.isParent) this.showApplet(cprop) }} onTouchStart={(e) => this.props.onDragStart(e, cprop, 'function')} onDragStart={(e) => this.props.onDragStart(e, cprop, 'function')} onTouchMove={(e) => this.onTouchMove(e, cprop)} onTouchEnd={(e) => this.onTouchEnd(e)} draggable={!cprop.isParent} style={{ touchAction: "none", position: 'relative', padding: '5px 5px 10px 5px', cursor: !cprop.isParent ? 'move' : 'pointer', borderBottom: '1px solid #f2f2f2' }}>
                                                        <div className="flexc">
                                                            <img draggable={false} src={cprop.icon} width="30px" height={'30px'} alt="" style={{ objectFit: 'cover', borderRadius: '30px', userSelect: 'none', WebkitUserSelect: 'none' }} />
                                                            <div className="text-start mld-3">
                                                                <p className="mt-0  text-semibold color-gray-3" style={{ fontSize: 11 }} >{checkTranslation(cprop.name)}</p>
                                                                <p className="mt-0  text-semibold color-gray-2" style={{ fontSize: 10 }} >@username</p>
                                                            </div>
                                                        </div>

                                                        <div className="flexcc">
                                                            {cprop.isParent && (
                                                                <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                            )
                                        })}
                                    </div>
                                    <div style={{ padding: '0px 2px' }}>

                                        {/* <LoaderButton
                                            onClick={() => this.postTask()}
                                            isLoading={this.state.isLoading}
                                            text={translate("Load More")}
                                            className="py-1 w-100 flexcb"
                                            // disabled={!this.state.canContinue}
                                            background='linear-gradient(to right, #7064FE, #6473FE)'
                                            icon={'/images/nexts.png'}
                                        /> */}

                                        {/* <button className="px-2  w-100 mb-1 flexcb border-radius-4" style={{ color: '#fff', backgroundColor: '#007aff' }}>
                                            <p className="text-smaller  py-2  text-semibold" >{translate("Show more")}</p>
                                            <div className="flexcc">
                                                <img className={"mld-2 transition invert "} src={'/images/nexts.png'} width="13px" alt="" />
                                            </div>
                                        </button> */}
                                    </div>
                                </Collapsible>
                            </div>
                        </div>



                        {Object.values(diagramGroups).map((prop, index) => {
                            return (
                                <div className="mb-2 pb-2" style={{ borderBottom: '0px solid #eee' }} key={prop.key}>
                                    <button className="p-0 px-2 mb-2 flexcb w-100" onClick={() => this.toggleOpen(prop.key)} >
                                        <div className="text-start">
                                            <p className="text-normal text-semibold " style={{ color: '#101010' }}>{checkTranslation(prop.title)}</p>

                                            {/* <p className="text-normal " style={{ color: '#456' }}>{prop.title}</p> */}
                                            {/* <p className="text-smallest " style={{color:'#9ab'}}>This is the description of this section</p> */}
                                        </div>
                                        <img className={"mld-2 transition opacity-2 " + (!this.state.closedGroups[prop.key] ? 'rotate-90' : '')} src={'/images/nexts.png'} width="13px" alt="" />
                                    </button>

                                    <Collapsible open={!this.state.closedGroups[prop.key]} transitionTime={100}>
                                        <div className="d-flex mb-2" style={{ flexWrap: 'wrap', alignItems: "stretch" }}>
                                            {Object.values(diagramComponents).map((cprop, index) => {
                                                if (!cprop.parent && cprop.group === prop.key)
                                                    return (
                                                        <div className=" p-1 mb-0" style={{ width: '50%' }} key={cprop.key}>
                                                            <div className=" h-100 text-center form-item " onClick={() => { if (cprop.isParent) this.showChildsList(cprop) }} onTouchStart={(e) => this.props.onDragStart(e, cprop, 'function')} onDragStart={(e) => this.props.onDragStart(e, cprop, 'function')} onTouchMove={(e) => this.onTouchMove(e, cprop)} onTouchEnd={(e) => this.onTouchEnd(e)} draggable={!cprop.isParent} style={{ touchAction: "none", position: 'relative', padding: '10px 5px', cursor: !cprop.isParent ? 'move' : 'pointer', borderRadius: 2, border: '1px solid #e2e6e8' }}>
                                                                <img draggable={false} src={cprop.icon} width="30px" alt="" style={{ userSelect: 'none', WebkitUserSelect: 'none' }} />
                                                                <p className="mt-1 text-smaller text-semibold color-gray-3" >{checkTranslation(cprop.title)}</p>

                                                                {cprop.isParent && (
                                                                    <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ position: 'absolute', top: 8, right: 8, userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                                )}
                                                            </div>
                                                        </div>
                                                    )
                                            })}
                                        </div>
                                    </Collapsible>
                                </div>
                            )
                        })}
                    </div>

                </SidebarView>
                {/* </div> */}

                {/* </div> */}



                {/* <div className={"blur-back digramSidePanel " + (this.state.sideClose ? 'sideClose' : '')}>
                    <div className="digramSidePanelList pt-3">
                        {Object.values(diagramGroups).map((prop, index) => {
                            return (
                                <div className="mb-3 pb-2" style={{ borderBottom: '1px solid #eee' }} key={prop.key}>
                                    <button className="p-0 px-2 mb-2 flexcb w-100" onClick={() => this.toggleOpen(prop.key)} >
                                        <div className="text-start">
                                            <p className="text-normal " style={{ color: '#456' }}>{prop.title}</p>
                                        </div>
                                        <img className={"mld-2 transition opacity-2 " + (!this.state.closedGroups[prop.key] ? 'rotate-90' : '')} src={'/images/nexts.png'} width="13px" alt="" />
                                    </button>

                                    <Collapsible open={!this.state.closedGroups[prop.key]} transitionTime={100}>
                                        <div className="d-flex mb-2" style={{ flexWrap: 'wrap', alignItems: "stretch" }}>
                                            {Object.values(diagramComponents).map((cprop, index) => {
                                                if (!cprop.parent && cprop.group === prop.key)
                                                    return (
                                                        <div className=" p-1 mb-0" style={{ width: '50%' }} key={cprop.key}>
                                                            <div onClick={() => { if (cprop.isParent) this.showChildsList(cprop.key) }} onTouchStart={(e) => this.props.onDragStart(e, cprop, 'function')} onDragStart={(e) => this.props.onDragStart(e, cprop, 'function')} onTouchMove={(e) => this.onTouchMove(e, cprop)} onTouchEnd={(e) => this.onTouchEnd(e)} draggable={!cprop.isParent} className=" h-100 text-center " style={{ touchAction: "none", position: 'relative', padding: '10px 5px', cursor: !cprop.isParent ? 'move' : 'pointer', backgroundImage: 'linear-gradient(#f2f6f8cc,#eaecef)', borderRadius: 2, border: '1px solid #e2e6e8' }}>
                                                                <img draggable={false} src={cprop.icon} width="32px" alt="" style={{ userSelect: 'none', WebkitUserSelect: 'none' }} />
                                                                <p className="" style={{ fontSize: 11, color: '#567', marginTop: 3 }}>{cprop.title}</p>

                                                                {cprop.isParent && (
                                                                    <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ position: 'absolute', top: 8, right: 8, userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                                )}
                                                            </div>
                                                        </div>
                                                    )
                                            })}
                                        </div>
                                    </Collapsible>
                                </div>
                            )
                        })}
                    </div>


                    <div className={"blur-back digramSidePanel " + (this.state.childsSideClose ? 'sideClose' : '')}>

                    </div>


                    <button className={"diagramSideHandler blur-back flexcc "} onClick={this.toggleSideOpen}>
                        <img src="/images/next-2.png" width="20px" alt="" />
                    </button>

                </div> */}


                <SidebarView width={this.props.width} ref={el => this.subSidebarView = el} sideOpen={false} hideOverlay={this.props.hideOverlay} paddingTop={'62px'} widthCondition={{ xs: "12", sm: '28%', md: '28%', lg: "28%", xl: "20%" }}>

                    <div className="scroll-no-scrollbar h-100">
                        <div className="flexc pt-3 mb-3 px-2">
                            <button onClick={() => this.showChildsList()} className="flexc p-0 mx-0 ">
                                <img className="reverse " src="/images/nexts.png" width="14px" alt="" />
                                {/* <span className="text-normal">{this.state.selectedParent?.name}</span> */}
                            </button>
                            <p className="text-semibold text-normal px-2" style={{ color: '#101010' }}>{checkTranslation(this.state.selectedParent?.name)}</p>
                        </div>

                        <div className="d-flex mb-2 w-100 " style={{ flexWrap: 'wrap', alignItems: "stretch" }}>

                            {Object.values(diagramGroups).map((prop, index) => {
                                return (
                                    <div className="mb-2 pb-2 w-100" style={{ borderBottom: '0px solid #eee' }} key={prop.key}>
                                        <button className="p-0 px-2 mb-2 flexcb w-100" onClick={() => this.toggleOpen(prop.key)} >
                                            <div className="text-start">
                                                <p className="text-small text-semibold " style={{ color: '#101010' }}>{checkTranslation(prop.title)}</p>

                                                {/* <p className="text-normal " style={{ color: '#456' }}>{prop.title}</p> */}
                                                {/* <p className="text-smallest " style={{color:'#9ab'}}>This is the description of this section</p> */}
                                            </div>
                                            <img className={"mld-2 transition opacity-2 " + (!this.state.closedGroups[prop.key] ? 'rotate-90' : '')} src={'/images/nexts.png'} width="13px" alt="" />
                                        </button>

                                        <Collapsible open={!this.state.closedGroups[prop.key]} transitionTime={100}>

                                            {Object.values(diagramComponents).map((cprop, index) => {
                                                if (!cprop.parent && cprop.group === prop.key) {
                                                    if (cprop.parents && this.state.selectedParent?.type && cprop.parents.includes(this.state.selectedParent.type)) {
                                                        return (
                                                            // <div className=" p-1 mb-0" style={{ width: '50%' }} key={cprop.key}>
                                                            //     <div onClick={() => { if (cprop.isParent) this.showChildsList(cprop.key) }} onTouchStart={(e) => this.props.onDragStart(e, cprop, 'function')} onDragStart={(e) => this.props.onDragStart(e, cprop, 'function')} onTouchMove={(e) => this.onTouchMove(e, cprop)} onTouchEnd={(e) => this.onTouchEnd(e)} draggable={!cprop.isParent} className=" h-100 text-center " style={{ touchAction: "none", position: 'relative', padding: '10px 5px', cursor: !cprop.isParent ? 'move' : 'pointer', backgroundImage: 'linear-gradient(#f2f6f8cc,#eaecef)', borderRadius: 2, border: '1px solid #e2e6e8' }}>
                                                            //         <img draggable={false} src={cprop.icon} width="32px" alt="" style={{ userSelect: 'none', WebkitUserSelect: 'none' }} />
                                                            //         <p className="" style={{ fontSize: 11, color: '#567', marginTop: 3 }}>{cprop.title}</p>

                                                            //         {cprop.isParent && (
                                                            //             <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ position: 'absolute', top: 8, right: 8, userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                            //         )}
                                                            //     </div>
                                                            // </div>

                                                            <div className="  mb-0" style={{ padding: 2, width: '100%' }} key={cprop.key}>
                                                                <div className="flexcb h-100 text-center  px-2" onClick={() => { this.onClick(cprop) }} onTouchStart={(e) => this.props.onDragStart(e, cprop, 'function')} onDragStart={(e) => this.props.onDragStart(e, cprop, 'function')} onTouchMove={(e) => this.onTouchMove(e, cprop)} onTouchEnd={(e) => this.onTouchEnd(e)} draggable={this.props.draggable && !cprop.isParent} style={{ touchAction: "none", position: 'relative', padding: '5px 5px 10px 5px', cursor: (this.props.draggable && !cprop.isParent) ? 'move' : 'pointer', borderBottom: '1px solid #f8f8f8' }}>
                                                                    <div className="flexc">
                                                                        <img draggable={false} src={cprop.icon} width="24px" height={'24px'} alt="" style={{ objectFit: 'cover', userSelect: 'none', WebkitUserSelect: 'none' }} />
                                                                        <div className="text-start mld-3">
                                                                            <p className="mt-0  text-semibold color-gray-3" style={{ fontSize: 12 }} >{checkTranslation(cprop.title)}</p>
                                                                            {/* <p className="mt-0  text-semibold color-gray-2" style={{ fontSize: 10 }} >@username</p> */}
                                                                        </div>
                                                                    </div>

                                                                    <div className="flexcc">
                                                                        {cprop.isParent && (
                                                                            <img draggable={false} src={'/images/cd-2.svg'} width="15px" alt="" style={{ userSelect: 'none', WebkitUserSelect: 'none', opacity: 0.3 }} />
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        )
                                                    }
                                                }
                                            })}

                                        </Collapsible>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </SidebarView>
                {/* <div className={"blur-back digramSidePanel " + (!this.state.showChildsSide ? 'sideClose' : '')}>
                    <div className="digramSidePanelList pt-3">
                        

                    </div>
                </div> */}

                {this.state.dragId && (
                    <div id="drag-ghost" className="drag-ghost" style={{ zIndex: 20000, position: 'absolute', top: 10, left: 0, height: 80, width: 80, backgroundColor: 'rgba(230,240,245,0.7)', border: '1px dotted #007aff40', borderRadius: 2 }}></div>
                )}



            </div>

        )
    }
}



export default DiagramSidebar;
